/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createReorderCustomerAttributesResponseFromDiscriminatorValue, serializeReorderCustomerAttributesRequest, serializeReorderCustomerAttributesResponse, type ErrorResponse, type ReorderCustomerAttributesRequest, type ReorderCustomerAttributesResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/customer-attributes/reorder
 */
export interface ReorderRequestBuilder extends BaseRequestBuilder<ReorderRequestBuilder> {
    /**
     * Rearranges the organization's customer attributes. Position is the display order — the attribute columns on the grids and the attribute tables on the detail pages follow it. Send every existing attribute exactly once, in the new order, identified by slug (display name is also accepted, case-insensitively) — adding, dropping, or repeating one is a 400.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ReorderCustomerAttributesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     put(body: ReorderCustomerAttributesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ReorderCustomerAttributesResponse | undefined>;
    /**
     * Rearranges the organization's customer attributes. Position is the display order — the attribute columns on the grids and the attribute tables on the detail pages follow it. Send every existing attribute exactly once, in the new order, identified by slug (display name is also accepted, case-insensitively) — adding, dropping, or repeating one is a 400.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: ReorderCustomerAttributesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReorderRequestBuilderUriTemplate = "{+baseurl}/api/organizations/customer-attributes/reorder";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReorderRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ReorderRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createReorderCustomerAttributesResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReorderCustomerAttributesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
